import { render, staticRenderFns } from "./JCard.vue?vue&type=template&id=75098168&"
import script from "./JCard.vue?vue&type=script&lang=js&"
export * from "./JCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports